import { Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import ThreeComponent from "../../../components/ThreeColumnsComponent";
import TableAttendances, { Attendance } from "./TableAttendances";
import { getMyAttendances } from "../../../api/s10OrganizationApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import MySnackbar from "../../../components/MySnackbar";


// const getToday = () => {
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);
//   return today;
// };

const getDaysAgo = (days: number, end = false) => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  date.setHours(end ? 23 : 0, end ? 59 : 0, 0, 0);
  return date;
};

const MyAttendances = () => {

    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [startDateOne, setStartDateOne] = useState<Date | null>(getDaysAgo(0));
    const [endDateOne, setEndDateOne] = useState<Date | null>(getDaysAgo(0, true));
    const [loadingOne, setLoadingOne] = useState<boolean>(false);
    const [attendancesOne, setAttendancesOne] = useState<Attendance[]>([]);

    const [startDateTwo, setStartDateTwo] = useState<Date | null>(getDaysAgo(7));
    const [endDateTwo, setEndDateTwo] = useState<Date | null>(getDaysAgo(0, true));
    const [loadingTwo, setLoadingTwo] = useState<boolean>(false);
    const [attendancesTwo, setAttendancesTwo] = useState<Attendance[]>([]);

    const [startDateThree, setStartDateThree] = useState<Date | null>(getDaysAgo(30));
    const [endDateThree, setEndDateThree] = useState<Date | null>(getDaysAgo(0, true));
    const [loadingThree, setLoadingThree] = useState<boolean>(false);
    const [attendancesThree, setAttendancesThree] = useState<Attendance[]>([]);

    const [snackBarMessage, setSnackBarMessage] = useState<any>();


    useEffect(() => {
        if (!startDateOne || !endDateOne || loadingOne || !companyselected || !connectionId) return;
        fetchAttendances(startDateOne, endDateOne, setLoadingOne, setAttendancesOne);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDateOne, endDateOne, companyselected, connectionId]);

    useEffect(() => {
        if (!startDateTwo || !endDateTwo || loadingTwo || !companyselected || !connectionId) return;
        fetchAttendances(startDateTwo, endDateTwo, setLoadingTwo, setAttendancesTwo);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDateTwo, endDateTwo, companyselected, connectionId]);

    useEffect(() => {
        if (!startDateThree || !endDateThree || loadingThree || !companyselected || !connectionId) return;
        fetchAttendances(startDateThree, endDateThree, setLoadingThree, setAttendancesThree);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDateThree, endDateThree, companyselected, connectionId]);

    const fetchAttendances = async (
        startDate: Date | null, 
        endDate: Date | null, 
        setLoading: (value: boolean) => void,
        setAttendances: (value: Attendance[]) => void,
    ) => {
        if (startDateOne! > endDateOne!) {
            setSnackBarMessage({
            success: false,
            msg: "La fecha inicial no puede ser mayor a la final",
            });
            return;
        }

        setLoading(true);
        try {
            const start = formatDateForApi(startDate!);
            const end = formatDateForApi(endDate!);
            const response = await getMyAttendances(start, end);

            if (response.data && Array.isArray(response.data)) {
                let data = response.data.map((a: any) => ({
                    ...a,
                    googleMapUrl: a.Latitude && a.Longitude
                    ? `https://www.google.com/maps?q=${a.Latitude},${a.Longitude}&z=17`
                    : null,
                }));

                setAttendances(data);
            } else {
                setAttendances([]);
                setSnackBarMessage({ success: false, msg: "Error al obtener marcaciones" });
            }
        } catch (error) {
            console.error(error);
            setSnackBarMessage({ success: false, msg: "Error de conexión" });
        } finally {
            setLoading(false);
        }
    };

    const formatDateForApi = (date: Date): string => {
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const ComponentOne = useCallback(() => (
        <TableAttendances
            setStartDate={setStartDateOne}
            startDate={startDateOne}
            setEndDate={setEndDateOne}
            endDate={endDateOne}
            key="tab-hoy"
            attendances={attendancesOne}
            loading={loadingOne}
        />
    ),[attendancesOne, endDateOne, loadingOne, startDateOne]);

    const ComponentTwo = useCallback(() => (
        <TableAttendances
            setStartDate={setStartDateTwo}
            startDate={startDateTwo}
            setEndDate={setEndDateTwo}
            endDate={endDateTwo}
            key="tab-7dias"
            attendances={attendancesTwo}
            loading={loadingTwo}
        />
    ),[attendancesTwo, endDateTwo, loadingTwo, startDateTwo]);

    const ComponentThree = useCallback(() => (
        <TableAttendances
            setStartDate={setStartDateThree}
            startDate={startDateThree}
            setEndDate={setEndDateThree}
            endDate={endDateThree}
            key="tab-30dias"
            attendances={attendancesThree}
            loading={loadingThree}
        />
    ),[attendancesThree, endDateThree, loadingThree, startDateThree]);

    return (
        <Grid container>
            <ThreeComponent
                useTabsNameAsTitle
                tabsTitle={["Hoy", "Últimos 7 días", "Últimos 30 días"]}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
            <MySnackbar
                open={!!snackBarMessage}
                msg={snackBarMessage?.msg || ""}
                severity={snackBarMessage?.success ? "success" : "error"}
                onClose={() => setSnackBarMessage(undefined)}
            />
        </Grid>
    );
};

export default MyAttendances;